<script>
  export let country
  export let margin
  export let height
  export let xScale
  export let yScale
  export let toggleClass
  export let formatter
</script>

<template>
  <line
    class="{toggleClass(country, 'line')}"
    x1="0"
    x2="{xScale(country.vaccine_index)}"
    y1="{yScale(country.medical_aid_index)}"
    y2="{yScale(country.medical_aid_index)}"
  >
  </line>
  <line
    class="{toggleClass(country, 'line')}"
    x1="{xScale(country.vaccine_index)}"
    x2="{xScale(country.vaccine_index)}"
    y1="{height - margin.top - margin.bottom}"
    y2="{yScale(country.medical_aid_index)}"
  >
  </line>
  <text
    class="{toggleClass(country, 'text')}"
    x="{xScale(country.vaccine_index)}"
    y="{height - margin.bottom + margin.top}"
    text-anchor="start"
    fill="currentColor"
  >
    {formatter(country.vaccine_index)}
  </text>
  <text
    class="{toggleClass(country, 'text')}"
    x="0"
    y="0"
    text-anchor="start"
    fill="currentColor"
    transform="translate(-40, {yScale(country.medical_aid_index)}) "
  >
    {formatter(country.medical_aid_index)}
  </text>
</template>
